import { FLUTTER_IFRAME_WRAPPER_MAP } from './../../flutter/flutter.consts.js';
import { resizeFrame, isDesktop, getStateAbbreviationFromURLPath, addLoadingSpinner, removeLoadingSpinner } from './../../flutter/flutter.utils.js';
// FlutterDeals.js
// TODO: Handle state changes and URL history
export default class FlutterDeals {

  constructor() {
    if (process.env.NODE_ENV === 'development') {
      console.log('flutter.deals: initializing');
    }
    this.loadDependencies().then(() => {
      this.initializeProperties();
      if (this.$currentWrapper.length >= 1) {
        this.initializeDealsPopup();
        addLoadingSpinner(this.$currentWrapper);
        if (this.debugMode) {
          console.log('flutter.deals: initialized');
        }
      }
    });
  }

  async loadDependencies() {
    await Promise.all([
      import(/* webpackMode: "eager" */ './flutter-deals.scss'),
      import(/* webpackMode: "eager" */ '../../scripts/dbs/dbs.utilities.querystring'),
      import(/* webpackMode: "eager" */ '../../plugins/semantic/modal'),
      import(/* webpackMode: "eager" */ '../../plugins/semantic/modal.scss'),
    ]);
  }


  initializeProperties() {
    this.$dealsHome = $(FLUTTER_IFRAME_WRAPPER_MAP['deals_home'])
    this.$dealsExplore = $(FLUTTER_IFRAME_WRAPPER_MAP['deals_explore'])
    this.isExplorePage = this.$dealsExplore.length >= 1;
    this.isHomePage = this.$dealsHome.length >= 1;
    this.$currentWrapper = this.isHomePage ? this.$dealsHome : this.$dealsExplore;

    // Resizing
    this.$window = $(window);
    this.minHeightDesktop = this.isHomePage ? 300 : 780;   // Desktop height so that the calendars always are visible
    this.minHeightMobile = this.isHomePage ? 300 : 350;    // Desktop height so that the calendars always are visible
    this.mobileBreakpoint = this.isHomePage ? 0 : 808;   // The width at which the flutter widget swaps from desktop to to mobile
    this.heightBuffer = this.isHomePage ? 15 : 15;        // height buffer underneath the widget

    this.localDebugEnabled = false;
    this.debugMode == this.localDebugEnabled && process.env.NODE_ENV === 'development';

    // Deals Popup
    this.dealsPopupInitialized = false;
    this.popupModalTemplate = `<div id="flutter_deals_popup" style="display:none"> <div class="content"> </div> </div>`
    this.DesktopCloseButtonTemplate = `<div class="closeWrapper"><button class="ui button close" onclick="$('#flutter_deals_popup').modal('hide');">Close</button></div>`
    this.MobileCloseButtonTemplate = `<i class="close icon" onclick="$('#flutter_deals_popup').modal('hide');"></i>`
    this.closeButtonTemplate = this.DesktopCloseButtonTemplate + this.MobileCloseButtonTemplate;
  }
  // initialize State Param handling
  // handlePopState
  // handleFlutterUpdate

  //
  handleEvent = (eventType, eventData) => {
    const self = this;
    if (self.debugMode) {
      console.log('flutter.events.handleDealsEvent: received event', eventType, eventData);
    }
    removeLoadingSpinner(this.$currentWrapper)
    switch (eventType) {
      case 'onAppStarted':
        removeLoadingSpinner(this.$currentWrapper)
        break;
      case 'onResize':
        this.handleResize(eventData);
        break;
      case 'showConditions':
        this.handleShowConditions(eventData)
        break;
      case 'applyDeal':
        this.handleApplyDeal(eventData)
        break;
      case 'statesSelected':
        this.handleStateSelection(eventData);
        break;
      case 'redirect':
          this.handleRedirection(eventData);
          break;
      default:
        if (self.debugMode) {
          console.error('flutter.events.handleDealsEvent: Unhandled event type', eventType, eventData);
          // TODO: Log this to k13 event log somehow
        }
        break;
    }
  }

  handleStateSelection = (eventData) => {
    const self = this;
    if (self.debugMode) {
      console.log('flutter.deals.handleStateSelection: received event', eventData);
    }
    const url = new URL(window.location.href);
    const states = eventData?.states;
    if (states == null || states.length == 0) {
      if (self.debugMode) {
        console.log('flutter.deals.handleStateSelection: No States provided', eventData);
      }
      // No states provided, remove states parameter from URL
      url.searchParams.delete('states');
      window.history.replaceState({}, '', url);
      return;
    }
    const statesParam = `${states.join(',')}`;
    const pathParts = url.pathname.split('/');
    const stateAbbreviation = getStateAbbreviationFromURLPath(pathParts[pathParts.length - 1]);
    // States selected, handle update states URL Parameter, and rewriting to remove the state path if multiple are selected
    // Don't push to history, we just want to sync states so that refreshes are handled
    if (states.length >= 2) {
      // Multiple are selected, if there's a state path, remove it

      if (pathParts.length > 2) { // If path is longer than just /deals
        pathParts.length = 2; // Truncate to just /deals
        url.pathname = pathParts.join('/');
      }
    } else if (!states.includes(stateAbbreviation)) {
      // They've selected another state, that doesn't match the current state path, so remove it
      if (pathParts.length > 2) {
        pathParts.length = 2; // Truncate to just /deals
        url.pathname = pathParts.join('/');
      }
      // Remove state path if it's not in the selected states
    } else if (states.length == 0) {
      // Remove state path if it exists as we have no states selected now
      if (pathParts.length > 2) {
        pathParts.length = 2; // Truncate to just /deals
        url.pathname = pathParts.join('/');
      }
    } else {
      // Likely they've just selected and unselected the same states
      // Not sure what this might be, but catching it in case
      if (self.debugMode) {
        console.warn("flutter.deals.handleStateSelection: Unhandled state selection", eventData);
      }
    }

    url.searchParams.set('states', statesParam)
    // Update URL without pushing to history
    console.log('Deals Url',url)
    window.history.replaceState({}, '', decodeURIComponent(url));
  }

  handleResize = (eventData) => {
    if (this.$dealsHome.length >= 1) {
      resizeFrame(
        this.$dealsHome,
        eventData.width,
        eventData.height,
        (isDesktop(this.mobileBreakpoint)) ? this.minHeightDesktop : this.minHeightMobile,
        this.heightBuffer
      );
    }
    if (this.$dealsExplore.length >= 1) {
      resizeFrame(
        this.$dealsExplore,
        eventData.width,
        eventData.height,
        (isDesktop(this.mobileBreakpoint)) ? this.minHeightDesktop : this.minHeightMobile,
        this.heightBuffer
      );
    }
  }
  initializeDealsPopup = () => {
    if (!this.dealsPopupInitialized) {
      this.popupModal = false;

      $('body').append(this.popupModalTemplate);
      this.popupModal = $("#flutter_deals_popup");
      this.popupModal.modal({
        closable: false,
      });
      this.dealsPopupInitialized = true;
    }
  }
  // Deal conditions popup modal

  handleShowConditions = (data) => {
    // Show the conditions popup
    data = data.replace(/body2/g, 'div');
    this.popupModal.children('.content').html(data + this.closeButtonTemplate);
    this.popupModal.show();
    this.popupModal.modal('show')
  }

  handleApplyDeal = (data) => {
    const self = this;
    // this function is fired when the user clicks on the apply deal button
    let currentUrl = window.location.origin
    // Extract required values
    var dealCode = data?.dealCode;
    var parkCode = data?.park?.code;
    var descriptionText = data.description
    if (typeof dealCode == 'undefined') {
      if (self.debugMode) {
        console.warn("Deal code is undefined")
      }
    }
    // Null checks here
    // Deal code might not be present
    var applyDealsUrlPath = `/deals/${parkCode.toLowerCase()}/${dealCode}/apply?dealText=${descriptionText}`
    //redirect the urls
    // TODO: maybe double check this is a valid redirect and we haven't got nulls/bad URLS
    window.location.href = currentUrl + applyDealsUrlPath;
  }
  handleRedirection = (eventData) => {
    let currentUrl = window.location.origin;
    let targetUrl = $('html').hasClass('dhp-theme') 
      ? currentUrl + '/terms-and-conditions/member-join' 
      : currentUrl + '/terms-and-conditions/gday-rewards';
    
    if (window.top) {
      window.top.open(targetUrl, '_blank');
    } else {
      window.open(targetUrl, '_blank');
    }
    // TODO improve the redirect logic to handle eventData.location
  }
}
